import { implementCustomInvariants } from '../__generated/implementation.js';
export const invariantExpressions = implementCustomInvariants({
    Shorts: {
        linerRequiredForTanThroughFabric: (self)=>self.liner !== 'none' || self.fabric !== 'tan through'
    }
});

//# sourceMappingURL=invariants.js.map